import React, { useContext } from 'react'
import { Typography, Icon } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import * as R from 'ramda'
import ReminderTime from './ReminderTime'
import { fromApiReminderDate } from 'app/main/notification/submit/NotiApiMapper'
import { NotificationAction } from '../notificationContext/NotificationActionProvider'
import { getDateTimeDiff } from 'libs/humanizedTimeIndicator/humanizedTimeIndicator'
import moment from 'moment'

const hasReminderDate = R.compose(
  R.not,
  R.anyPass([R.isNil, R.isEmpty]),
  R.prop(fromApiReminderDate),
)

export const isReminded = (reminderDate) => {
  const { diffTimeInMilliseconds } = getDateTimeDiff(
    moment(),
    moment(reminderDate),
  )
  return diffTimeInMilliseconds > 0
}

const CancelReminderButton = ({ notification }) => {
  const notiAction = useContext(NotificationAction)
  const onClickCancel = () => {
    notiAction.cancelReminder(notification)
  }
  const displayReminderDate = R.prop('reminderDate', notification)
  const displayReminderTimezone = R.prop('reminderTimezone', notification)

  if (!hasReminderDate(notification)) return null
  else
    return (
      <div className="flex py-8">
        <Typography color="primary" className="text-xs">
          <ReminderTime
            reminderDateTime={displayReminderDate}
            reminderTimezone={displayReminderTimezone}
          />
        </Typography>
        {!isReminded(R.prop(fromApiReminderDate, notification)) && (
          <div className="flex flex-row ltr:pl-16 rtl:pr-16 ">
            <Typography
              color="secondary"
              className="text-xs cursor-pointer font-semibold hover:underline"
              onClick={onClickCancel}
            >
              <Icon className="text-xs align-middle self-center mb-1 ltr:mr-4 rtl:ml-4 font-semibold">
                alarm
              </Icon>
              <FormattedMessage id="notificationTimeline.card.cancelReminder" />
            </Typography>
          </div>
        )}
      </div>
    )
}

export default React.memo(CancelReminderButton)
